// ref: https://github.com/jusbrasil/finder/blob/e54b649114e41dea78765c4014f746dda199b940/src/components/search-filters/checkbox-filter.jsx#L45-L83
export enum SerpQueryParam {
  Query = 'q',
  Page = 'p',
  DateRange = 'l',
  State = 'uf',
  Order = 'o',
  DateFrom = 'dateFrom',
  DateTo = 'dateTo',
  Court = 'tribunal',
  JurisType = 'jurisType',
  IdDoutrina = 'idDoutrina',
  MotionType = 'tipopeca',
  DoctrineType = 'tipoDoutrina',
  JournalType = 'journalType',
  DoctrineLawArea = 'areasDireito',
  Rapporteur = 'magistrado',
  JudgingOrgan = 'orgaoJulgador',
  FaixaEtaria = 'faixaEtaria',
  DocId = 'docId',
  ImplicitFilterDisabled = 'implicitFilterDisabled',
  Tipo = 'tipo',
  Cargo = 'cargo',
  Partido = 'partido',
}
